import "./App.css";
import Home from "./Pages/Home";
import SignUp from "./Pages/SignUp";
import SignIn from "./Pages/SignIn";
import InProgressPage from "./Pages/InProgressPage";
import Workspace from "./Pages/Workspace";
import IndividualProfile from "./Pages/IndivisualProfile";
import EditIndividual from "./Pages/EditIndivisual";
import SearchPeople from "./Pages/SearchPeople";
import ChangePassword from "./Pages/ChangePassword";
import { MyAiTeam } from "./Pages/MyAiTeam";
import Messages from "./Pages/Messages";
import AllAIProjects from "./Pages/AllAIProjects";
import AiProjectSuccessMatch from "./Pages/AiProjectSuccessMatch";
import AiTeam from "./Pages/AiTeam";
import Admin from "./Pages/Admin";
import SuperAdmin from "./Pages/SuperDaimlasAdmin";
import MyAiTasks from "./Pages/MyAiTasks";
import AiTeamPreview from "./Pages/AiTeamPreview";
import ProjectTitle from "./Pages/ProjectTitle";
import DatePicker from "./Components/DatePicker";
import AddNewAiTask from "./Components/AddNewAiTask";
import MyAIProjects from "./Pages/MyAiProjects";
import AvatarComponent from "./Components/AvatarComponent";
import NotificationComponent from "./Components/NotificationComponent";
import NotificationSettingModal from "./Components/NotificationSettingModal";
import AddNewUserModal from "./Components/AddNewUserModal";
import { Routes, Route, Outlet, Link, BrowserRouter } from "react-router-dom";
import EmailVerified from "./Pages/EmailVerified";
import SearchPeopleEmpty from "./Pages/SearchPeopleEmpty";
import AllTasks from "./Pages/AllTasks";
import TeamMatchingSuccessPage from "./Pages/TeamMatchingSuccessPage";
import ViewProjectNotAssigned from './Pages/ViewProjectNotAssigned'
import AddAiProject from "./Pages/AddAiProject";
import AssignTasksToTeam from "./Pages/AssignTasksToTeam";
import NewAdmin from "./Pages/NewAdmin";
import SearchAiTeamEmpty from "./Pages/SearchAiTeamEmpty";
import AiTaskEmpty from './Pages/AiTaskEmpty'
import AllProjectEmpty from "./Pages/AllProjectEmpty";
import AiProjectSuccessUploadError from "./Pages/AiProjectSuccessUploadError";
import AskGenerativeAi from "./Pages/AskGenerativeAi";
import AskGenerativeAiEmpty from "./Pages/AskGenerativeAiEmpty";
import PeopleEmpty from "./Pages/PeopleEmpty";
import ForgetPasswordPage from "./Pages/ForgetPasswordPage";


function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/check-email" element={<InProgressPage />} />
          <Route path="/email-verified" element={<EmailVerified />} />
          <Route path="/workspace" element={<Workspace />} />
          <Route path="/individual-profile" element={<IndividualProfile />} />
          <Route path="/individual-profile/edit" element={<EditIndividual />} />
          <Route
            path="/individual-profile/update-password"
            element={<ChangePassword />}
          />
          <Route path="/search-people" element={<SearchPeople />} />
          <Route path="/search-people-empty" element={<SearchPeopleEmpty />} />
          <Route path="/my-projects" element={<MyAIProjects />} />
          <Route path="/all-projects" element={<AllAIProjects />} />
          <Route path="/all-tasks" element={<AllTasks />} />
          <Route path="/my-tasks" element={<MyAiTasks />} />
          <Route path="/project-success" element={<AiProjectSuccessMatch />} />
          <Route path="/view-project" element={<ProjectTitle />} />
          <Route path="/team-profile" element={<AiTeam />} />
          <Route path="/team-profile/preview" element={<AiTeamPreview />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/super-admin" element={<SuperAdmin />} />
          <Route path="/matching-team-success" element={<TeamMatchingSuccessPage />} />
          <Route path="/view-project-not-assigned" element={<ViewProjectNotAssigned />} />
          <Route path="/my-ai-team" element={<MyAiTeam />} />
          <Route path="/add-ai-project" element={<AddAiProject />} />
          <Route path="/assign-project-team" element={<AssignTasksToTeam />} />
          <Route path="/new-admin" element={<NewAdmin />} />
          <Route path="/search-team-empty" element={<SearchAiTeamEmpty />} />
          <Route path="/ai-task-empty" element={<AiTaskEmpty />} />
          <Route path="/all-project-empty" element={<AllProjectEmpty />} />
          <Route path="/ai-project-no-match" element={<AiProjectSuccessUploadError />} />
          <Route path="/people-empty" element={<PeopleEmpty />} />
          <Route path="/ask-generative-ai" element={<AskGenerativeAi />} />
          <Route path="/ask-generative-ai-empty" element={<AskGenerativeAiEmpty />} />
          <Route path="/forgot-password" element={<ForgetPasswordPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
